export default __webpack_public_path__ + "media/e0cc9fe49171c5c39148ed4489fb462b59bacb9de7dbd425fe74ac0f87735ed0.svg";